import { useLocaleStore } from '../stores/localeStore';
import { translate } from './translate';
export function useTranslation() {
    const locale = useLocaleStore((state) => state.locale);
    return {
        locale,
        t: (key, params) => translate(locale, key, params),
    };
}
